var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8633 11.2036L8.93474 8.27504C9.66269 7.39966 10.1013 6.27558 10.1013 5.05078C10.1013 2.26577 7.83555 0 5.05066 0C2.26571 0 0 2.26577 0 5.05078C0 7.83561 2.26571 10.1012 5.05066 10.1012C6.27539 10.1012 7.39954 9.66269 8.27491 8.93474L11.2036 11.8633C11.2946 11.9545 11.4141 12 11.5334 12C11.6528 12 11.7723 11.9545 11.8634 11.8633C12.0456 11.6811 12.0456 11.3858 11.8633 11.2036ZM0.933107 5.05078C0.933107 2.78028 2.78022 0.933107 5.05066 0.933107C7.32103 0.933107 9.16808 2.78028 9.16808 5.05078C9.16808 7.32109 7.32103 9.16808 5.05066 9.16808C2.78022 9.16808 0.933107 7.32109 0.933107 5.05078Z",
    fill: "#002733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.8d7389903332489d2e5a1aba8a1af394.svg";
export { ForwardRef as ReactComponent };